import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'poOrderBy'
})
export class PoOrderByPipe implements PipeTransform {

  transform(array: any, field: string, asc: boolean): any[] {
    if (!Array.isArray(array)) {
      return;
    }

    if (asc) {
    array.sort((a: any, b: any) => {
    if (a[field] === null) {
    a[field] = '';
    }

    if (b[field] === null) {
    b[field] = '';
    }
    if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  } else {

    array.sort((a: any, b: any) => {

      if (a[field] === null) {
        a[field] = '';
        }
      if (b[field] === null) {
        b[field] = '';
        }
      if (a[field] > b[field]) {
        return -1;
      } else if (a[field] < b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;

  }
  }

}
